/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// React Router
import { Link } from 'react-router-dom';
// Images
import spigot from '../../assets/images/minecraft/spigot.svg';
import paper from '../../assets/images/minecraft/paper.svg';
import atl from '../../assets/images/minecraft/atl.svg';
import ftb from '../../assets/images/minecraft/ftb.svg';
import bukkit from '../../assets/images/minecraft/bukkit.svg';
import pixelmon from '../../assets/images/minecraft/pixelmon.svg';
import technic from '../../assets/images/minecraft/technic.svg';

const Modpacks = () => {
    return (
        <section className="mod-packs py-28">
            <div className="content bg-primaryDark py-28">
                <div className="max-w-7xl mx-auto px-5 sm:px-5 lg:px-5">
                    <h1 className="text-gray-100 font-semibold text-center text-3xl mb-9">Modpacks & Server Types</h1>
                    <p className="text-gray-300 text-center text-xl mb-0 sm:mb-0 md:mb-0 lg:mb-24">We offer all of the popular Minecraft modpacks and server types. Below is some of what we cover. 1-Click intalls & swap at any time. Click here for a full list!</p>
                </div>
                <div className="hidden sm:hidden md:hidden lg:grid grid-cols-7 items-center">
                    <div>
                        <img src={spigot} alt="Spigot" className="block mx-auto" />
                    </div>
                    <div>
                        <img src={paper} alt="PaperMC" className="block mx-auto" />
                    </div>
                    <div>
                        <img src={atl} alt=" ATL" className="block mx-auto" />
                    </div>
                    <div>
                        <img src={ftb} alt="FTB" className="block mx-auto" />
                    </div>
                    <div>
                        <img src={bukkit} alt="Bukkit" className="block mx-auto" />
                    </div>
                    <div>
                        <img src={pixelmon} alt="Pixelmon" className="block mx-auto" />
                    </div>
                    <div>
                        <img src={technic} alt="Technic" className="block mx-auto" />
                    </div>
                </div>
            </div>
            <div className="view-more flex justify-center">
                <Link to="/modpacks" className="bg-primary hover:bg-secondary px-16 py-4 text-gray-100 hover:text-white rounded-lg transition" Style="margin-top: -30px;">View all Modpacks</Link>
            </div>
        </section>
    )
}

export default Modpacks